import React from 'react'
var FA = require('react-fontawesome')

const GameButton = ctx => {
  const { action, setGlobalError, text, submitted, setSubmitted, isFullWidth, loading } =  ctx
  const submit = async (e) => {
    e.preventDefault()
    if(!submitted) {
      setSubmitted(true)
      try {
        await action()
      } catch (er) {
        setGlobalError(er)
      }
      setSubmitted(false)
    }
  }
  const cssClasses = isFullWidth ? "is-pulled-right button is-link is-large is-fullwidth" : "is-pulled-right button is-link is-large"

  return <span>
    <a disabled={loading} className={loading ? `loading ${cssClasses}` : cssClasses} onClick={submit}>
      { loading ?<FA name="spinner" className={"fa-spin pad-right"} /> : null}
      {text}
    </a>
    <style jsx>{`
      .pad-right {
        margin-right:5px;
      }
      `}</style>
    </span>

}

export default GameButton
